export const wishlistServiceError =
  "We couldn’t update your favorites. Check your connection and try again.";

export const wishlistMergeNotice =
  "Your saved favorites will merge when the account service is available.";
